import { ImgProps } from "assets/images/types";

export default function ImgProtea(props: ImgProps) {
	const { height = 48, width = 136 } = props;
	return (
		<img
			src="/assets/images/companies/protea.webp"
			alt="Instituto Protea logo"
			loading="lazy"
			width={width}
			height={height}
		/>
	);
}
